import React from "react";

export default () => <p style={{ padding: "1rem" }}>You have not been given access to any Admin pages</p>;
